// frontend/src/modules/funcionarios/components/FuncionariosList.js
import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaEye, FaUser, FaSearch, FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

function FuncionariosList({ empresaId }) {
  const [funcionarios, setFuncionarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchType, setSearchType] = useState('todos');
  const [filtered, setFiltered] = useState([]);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const token = localStorage.getItem('token');

  const fetchFuncionarios = async () => {
    setLoading(true);
    try {
      let url = `/api/empresa/${empresaId}/funcionarios`;
      
      if (searchTerm.trim()) {
        url = `/api/funcionarios/buscar?q=${encodeURIComponent(searchTerm)}&empresa_id=${empresaId}`;
      }
      
      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (!response.ok) throw new Error('Erro ao buscar funcionários');
      
      const data = await response.json();
      const lista = Array.isArray(data) ? data : (data.funcionarios || []);
      setFuncionarios(lista);
      setFiltered(lista);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFuncionarios();
  }, [searchTerm]);

  const handleSearch = (e) => {
    e.preventDefault();
    fetchFuncionarios();
  };

  const handleClearSearch = () => {
    setSearchTerm('');
    setSearchType('todos');
    fetchFuncionarios();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este funcionário?')) return;
    try {
      const response = await fetch(`/api/funcionarios/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao excluir');
      fetchFuncionarios();
    } catch (err) {
      setError(err.message);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;
  if (error) return <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>❌ {error}</div>;

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>👥 Funcionários</h2>
        <button 
          onClick={() => navigate('/funcionarios/novo')} 
          style={{ 
            padding: isMobile ? '8px 16px' : '10px 20px',
            backgroundColor: '#28a745', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            fontSize: isMobile ? '13px' : '14px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            justifyContent: 'center',
            width: isMobile ? '100%' : 'auto'
          }}
        >
          <FaPlus /> Novo Funcionário
        </button>
      </div>

      {/* Barra de Busca */}
      <div style={{ 
        backgroundColor: 'white', 
        padding: isMobile ? '12px' : '15px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '20px'
      }}>
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ flex: 1, minWidth: isMobile ? '150px' : '250px' }}>
            <input
              type="text"
              placeholder="🔍 Buscar por nome, CPF, telefone..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: isMobile ? '8px 12px' : '10px 15px',
                border: '1px solid #ddd',
                borderRadius: '4px',
                fontSize: isMobile ? '13px' : '14px'
              }}
            />
          </div>
          <button 
            type="submit"
            style={{
              padding: isMobile ? '8px 16px' : '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              flex: isMobile ? '1' : '0',
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              justifyContent: 'center'
            }}
          >
            <FaSearch /> Buscar
          </button>
          {searchTerm && (
            <button 
              type="button"
              onClick={handleClearSearch}
              style={{
                padding: isMobile ? '8px 16px' : '10px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: isMobile ? '13px' : '14px',
                flex: isMobile ? '1' : '0',
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                justifyContent: 'center'
              }}
            >
              <FaTimes /> Limpar
            </button>
          )}
          <span style={{ marginLeft: 'auto', color: '#6c757d', fontSize: isMobile ? '12px' : '14px' }}>
            {funcionarios.length} funcionário(s)
          </span>
        </form>
        <div style={{ marginTop: '8px', display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          <small style={{ color: '#6c757d', fontSize: isMobile ? '10px' : '12px' }}>
            Busca por: Nome • CPF • Telefone • Email • PIS/PASEP • CTPS
          </small>
        </div>
      </div>

      {/* Lista de Funcionários */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '10px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
        {funcionarios.length === 0 ? (
          <div style={{ textAlign: 'center', padding: isMobile ? '30px' : '40px' }}>
            {searchTerm ? (
              <>
                <p style={{ fontSize: isMobile ? '16px' : '18px', margin: 0 }}>
                  🔍 Nenhum funcionário encontrado para "{searchTerm}"
                </p>
                <button 
                  onClick={handleClearSearch}
                  style={{ marginTop: '10px', padding: '8px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: isMobile ? '13px' : '14px' }}
                >
                  Limpar busca
                </button>
              </>
            ) : (
              <>
                <div style={{ fontSize: '48px', marginBottom: '10px' }}>📭</div>
                <p style={{ fontSize: isMobile ? '16px' : '18px', margin: 0, color: '#6c757d' }}>Nenhum funcionário cadastrado</p>
                <button 
                  onClick={() => navigate('/funcionarios/novo')} 
                  style={{ marginTop: '10px', padding: '8px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: isMobile ? '13px' : '14px' }}
                >
                  <FaPlus /> Cadastrar primeiro funcionário
                </button>
              </>
            )}
          </div>
        ) : isMobile ? (
          // ============================================
          // MOBILE - CARDS
          // ============================================
          <div>
            {funcionarios.map(func => (
              <div
                key={func.id}
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '10px',
                  borderLeft: `4px solid ${func.ativo ? '#28a745' : '#dc3545'}`
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '5px' }}>
                  <strong style={{ fontSize: '14px' }}>
                    <FaUser style={{ marginRight: '6px', color: '#6c757d', fontSize: '12px' }} />
                    {func.nome_completo}
                  </strong>
                  <span style={{
                    padding: '2px 8px',
                    borderRadius: '10px',
                    backgroundColor: func.ativo ? '#d4edda' : '#f8d7da',
                    color: func.ativo ? '#155724' : '#721c24',
                    fontSize: '10px'
                  }}>
                    {func.ativo ? '✅ Ativo' : '❌ Inativo'}
                  </span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '12px', color: '#6c757d' }}>
                  <div><strong>CPF:</strong> {func.cpf || '-'}</div>
                  <div><strong>Telefone:</strong> {func.telefone || '-'}</div>
                  <div><strong>Salário:</strong> {func.salario ? formatCurrency(func.salario) : '-'}</div>
                  <div><strong>Admissão:</strong> {formatDate(func.data_admissao)}</div>
                </div>
                <div style={{ marginTop: '8px', display: 'flex', gap: '8px', justifyContent: 'flex-end', borderTop: '1px solid #dee2e6', paddingTop: '8px' }}>
                  <button 
                    onClick={() => navigate(`/funcionarios/${func.id}`)} 
                    style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer' }}
                    title="Ver detalhes"
                  >
                    <FaEye />
                  </button>
                  <button 
                    onClick={() => navigate(`/funcionarios/editar/${func.id}`)} 
                    style={{ background: 'none', border: 'none', color: '#ffc107', cursor: 'pointer' }}
                    title="Editar"
                  >
                    <FaEdit />
                  </button>
                  <button 
                    onClick={() => handleDelete(func.id)} 
                    style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}
                    title="Excluir"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          // ============================================
          // DESKTOP - TABELA
          // ============================================
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Nome</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>CPF</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Telefone</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Email</th>
                <th style={{ padding: '10px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>Salário</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Admissão</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Status</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {funcionarios.map(func => (
                <tr key={func.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                  <td style={{ padding: '10px' }}>
                    <FaUser style={{ marginRight: '8px', color: '#6c757d' }} />
                    {func.nome_completo}
                  </td>
                  <td style={{ padding: '10px' }}>{func.cpf || '-'}</td>
                  <td style={{ padding: '10px' }}>{func.telefone || '-'}</td>
                  <td style={{ padding: '10px' }}>{func.email || '-'}</td>
                  <td style={{ padding: '10px', textAlign: 'right' }}>
                    {func.salario ? formatCurrency(func.salario) : '-'}
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    {formatDate(func.data_admissao)}
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <span style={{
                      padding: '3px 10px',
                      borderRadius: '12px',
                      backgroundColor: func.ativo ? '#d4edda' : '#f8d7da',
                      color: func.ativo ? '#155724' : '#721c24'
                    }}>
                      {func.ativo ? '✅ Ativo' : '❌ Inativo'}
                    </span>
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <button 
                      onClick={() => navigate(`/funcionarios/${func.id}`)} 
                      style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', marginRight: '8px' }}
                      title="Ver detalhes"
                    >
                      <FaEye />
                    </button>
                    <button 
                      onClick={() => navigate(`/funcionarios/editar/${func.id}`)} 
                      style={{ background: 'none', border: 'none', color: '#ffc107', cursor: 'pointer', marginRight: '8px' }}
                      title="Editar"
                    >
                      <FaEdit />
                    </button>
                    <button 
                      onClick={() => handleDelete(func.id)} 
                      style={{ background: 'none', border: 'none', color: '#dc3545', cursor: 'pointer' }}
                      title="Excluir"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default FuncionariosList;